export const BASIC_POLL_VOTE_TYPES = Object.freeze({
  MULTIPLE_CHOICE: "MULTIPLE_CHOICE",
  RANKED_CHOICE: "RANKED_CHOICE",
});

export const BASIC_POLL_STATUSES = Object.freeze({
  OPEN: "OPEN",
  FINALIZED: "FINALIZED",
  CLOSED: "CLOSED",
});

// Shared write-in length cap. Enforced both at the voting surface (textarea
// maxLength + live counter) and at submit time (group modal validation), so the
// two can't drift.
export const MAX_WRITE_IN_LENGTH = 120;

export function resolveBasicPollVoteType(value) {
  return value === BASIC_POLL_VOTE_TYPES.RANKED_CHOICE
    ? BASIC_POLL_VOTE_TYPES.RANKED_CHOICE
    : BASIC_POLL_VOTE_TYPES.MULTIPLE_CHOICE;
}

export function resolveBasicPollStatus(value) {
  if (value === BASIC_POLL_STATUSES.FINALIZED) return BASIC_POLL_STATUSES.FINALIZED;
  if (value === BASIC_POLL_STATUSES.CLOSED) return BASIC_POLL_STATUSES.CLOSED;
  return BASIC_POLL_STATUSES.OPEN;
}
